import React, { useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { API_BASE_URL } from '../../api';

const AddClient = () => {
    const [formData, setFormData] = useState({
        full_name: '',
        company_name: '',
        location: '',
        city: '',
        mobile_no: '',
        email_id: '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const headers = {
            authorization: "Bearer " + localStorage.getItem("authToken"),
            user_id: localStorage.getItem("userId"),
        };

        try {
            const response = await axios.post(`${API_BASE_URL}/api/client`, formData, { headers });
            if (response.status === 201) {
                Swal.fire({
                    icon: 'success',
                    title: 'Client Added',
                    text: 'Client has been added successfully!',
                    confirmButtonColor: '#3085d6',
                });
                
                // Reset the form data after successful submission
                setFormData({
                    full_name: '',
                    company_name: '',
                    location: '',
                    city: '',
                    mobile_no: '',
                    email_id: '',
                });
                window.location.reload();
            }
        } catch (error) {
            console.error('Error adding client:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to add client. Please try again.',
                confirmButtonColor: '#d33',
            });
        }
    };

    return (
        <div className="modal fade" id="add_client">
            <div className="modal-dialog modal-dialog-centered modal-lg">
                <div className="modal-content text-start">
                    <div className="modal-header">
                        <h4 className="modal-title">Add New Client</h4>
                        <button type="button" className="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
                            <i className="fa fa-times"></i>
                        </button>
                    </div>
                    <form onSubmit={handleSubmit}>
                        <div className="tab-content" id="myTabContent">
                            <div className="tab-pane fade show active" id="basic-info" role="tabpanel" aria-labelledby="info-tab" tabIndex="0">
                                <div className="modal-body pb-0">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label className="form-label">Name <span className="text-danger">*</span></label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="full_name"
                                                    value={formData.full_name}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label className="form-label">Company Name</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="company_name"
                                                    value={formData.company_name}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label className="form-label">Location <span className="text-danger">*</span></label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="location"
                                                    value={formData.location}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label className="form-label">City <span className="text-danger">*</span></label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="city"
                                                    value={formData.city}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label className="form-label">Mobile No <span className="text-danger">*</span></label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="mobile_no"
                                                    value={formData.mobile_no}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label className="form-label">Email <span className="text-danger">*</span></label>
                                                <input
                                                    type="email"
                                                    className="form-control"
                                                    name="email_id"
                                                    value={formData.email_id}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-outline-light border me-2" data-bs-dismiss="modal">Cancel</button>
                                    <button type="submit" className="btn btn-primary">Save</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default AddClient;
